import * as React from "react";

export const Page = ({title, children}) => (<main>
    <title>mikalajunas.dev{title ? ` - ${title}` : ''}</title>
    {children}
</main>);